module.exports = __webpack_public_path__ + "static/media/video.a1ae7e24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/WestCoastWaste/video.jpg
// module id = 311
// module chunks = 0